import "./Joystickb.css";
import { stateTouchCircle } from "../store";
import { stateDevice } from "../store";
import { useSnapshot } from "valtio";


import { Joystick } from "react-joystick-component";
import { useEffect } from "react";
import { useState } from "react";


export default function JoystickMovement() {

  const [joySize, setjoySize] = useState()
  const [joysizeThumb, setjoysizeThumb] = useState()

const snapIsMobile = useSnapshot(stateDevice)

  // Dreh-Empfindlichkeit: war vorher der Tippfehler "e.x / 5,5" (Komma-
  // Operator → effektiv /5). Jetzt bewusst als Konstante — bei Bedarf hier
  // tunen (kleinerer Wert = schnelleres Drehen).
  const TURN_DIVISOR = 5;
  // Radiale Deadzone: leicht schiefer Daumen soll den Spieler nicht schon
  // drehen/bewegen. Unterhalb: null. Oberhalb: weich von 0 hochskaliert,
  // damit an der Deadzone-Kante kein Sprung entsteht.
  const DEADZONE = 0.12;

  const handleMove = (e) => {
    let x = e.x ?? 0;
    let y = e.y ?? 0;
    const mag = Math.hypot(x, y);

    if (mag < DEADZONE) {
      stateTouchCircle.x = 0;
      stateTouchCircle.y = 0;
      return;
    }

    const rescale = (mag - DEADZONE) / (1 - DEADZONE) / mag;
    x *= rescale;
    y *= rescale;

    stateTouchCircle.x = x / TURN_DIVISOR;
    stateTouchCircle.y = -y;
  };
  const handleStop = (e) => {
   
    // console.log(e);
    stateTouchCircle.joystickMove = false
    stateTouchCircle.x = 0;
    stateTouchCircle.y = 0;
  };

  const handleStart = (e) => {
   
    // console.log(e);
    stateTouchCircle.joystickMove = true

  };


  useEffect(()=>{
    if (snapIsMobile.isMobile && !snapIsMobile.isTablet)
    {
      setjoySize(100)
      setjoysizeThumb(40)

    }
    else{
      setjoySize(150)
      setjoysizeThumb(70)
    }
    
      },[snapIsMobile.isMobile])

 
  return (
    <div className="joystickLeft">
   <Joystick
   
        size={joySize}
        baseColor="red"
        stickColor="blue"
        stickSize={joysizeThumb}
        move={handleMove}
        stop={handleStop}
        start = {handleStart}
        baseImage="./UI/JoystickBackground.png"
        stickImage="./UI/JoystickThumb.png"
        // throttle = {100}
      />
    </div>
  );
}
